
export const AssistantTrading=()=> {
  return (
    <>
      <section className="section_contact">
        <div>Salut</div>
      </section>
    </>
  );
}

